<mat-sidenav-container class="container">
    <mat-sidenav class="sidenav" mode="side" opened
    fixedInViewport="true" fixedTopGap="64">
        <mat-nav-list class="nav-list">
            <a mat-list-item routerLink="/">
                <i class="material-icons">
                    home
                </i>
                Início
            </a>
            <a *ngIf="jsonLogin && jsonLogin['email']" mat-list-item routerLink="/products">
                <i class="material-icons">
                    topic
                </i>
                Denúncias
            </a>
            <a mat-list-item routerLink="/products/create">
                <i class="material-icons">
                    add
                </i>
                Criar Denúncia
            </a>
            <a *ngIf="jsonLogin && jsonLogin['email']" mat-list-item routerLink="/denuncias-arquivadas">
                <i class="material-icons">
                    archive
                </i>
                Denúncias Arquivadas
            </a>
            <!-- <a mat-list-item routerLink="/duvidas">
                <i class="material-icons">
                    contact_support
                </i>
                Dúvidas
            </a> -->
            <!-- <a mat-list-item (click)="openAutores()" style="bottom: 0; position: absolute; margin-bottom: 8px;">
                <i class="material-icons">
                    people_alt
                </i>
                Autores
            </a> -->
        </mat-nav-list>
    </mat-sidenav>
    <mat-sidenav-content class="content">
        <router-outlet></router-outlet>
    </mat-sidenav-content>
</mat-sidenav-container>